import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';
import { Text } from '~/shared/components/Text';
import { breakpoints } from '~/theme';

export const Section = styled.div(() => ({
    display: 'grid',
}));

export const Header = styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.space[2],
    alignItems: 'flex-start',
    margin: `${theme.space[4]} 0 ${theme.space[3]}}`,
}));

export const Footer = styled.div(({ theme }) => ({
    position: 'relative',
    marginTop: theme.space[4],
}));

export const SearchContainer = styled.div(() => ({
    minWidth: '100px',
    maxWidth: '350px',

    [breakpoints.md]: { minWidth: '350px' },
}));

export const Filter = styled.div((props) => ({
    position: 'relative',
    alignSelf: 'start',
    button: { width: 120 },
}));

export const DownloadDocuments = styled.div(() => ({
    marginLeft: 'auto',
}));

export const TableContainer = styled.div((props) => ({
    overflowX: 'scroll',
    '::-webkit-scrollbar': {
        display: 'none',
    },
}));

export const TableCellLink = styled(Link)(({ theme }) => ({
    '--svg-width': theme.space[4],
    color: theme.colors.brandBlue,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    position: 'relative',
    textAlign: 'left',
    span: {
        span: {
            marginLeft: '0px',
        },
    },

    svg: {
        width: 'var(--svg-width)',
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        right: 'var(--svg-width)',
        bottom: 2,
        height: '1px',
        width: 'calc(100% - var(--svg-width))',
        backgroundColor: theme.colors.brandBlue,
    },
    '&:hover:after, &:active:after, &:focus:after': {
        width: '0%',
        transition: 'width 0.3s ease-in-out',
    },
    '&:hover, &:active, &:focus': {
        textDecoration: 'none',
    },
}));

export const PageSetter = styled.div(({ theme }) => ({
    display: 'none',
    [breakpoints.md]: {
        height: '100%',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.space[1],
    },
}));

export const Pagination = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space[6],
}));

export const StyledText = styled(Text)((props) => ({
    whiteSpace: 'nowrap',
}));

export const StyledPrice = styled(Text)((props) => ({
    whiteSpace: 'nowrap',
    textAlign: 'right',
    width: '100%',
}));

export const SkeletonSpacer = styled.div(() => ({
    height: 2,
}));

export const FilterWrapper = styled.div(({ theme }) => ({
    gridRow: '3 / 4',
    marginBottom: theme.space[2],
}));
